/**
 * web/src/lib/actionFeedback.ts — one place where a failed in-app action
 * announces itself (UX review H7, card ESidDNa3mmaP).
 *
 * The catch blocks behind kudos, request transitions, date actions, the nudge
 * quick-picks, Notebook saves and question answers used to call only
 * `console.error`, so a failure looked exactly like a success: the button
 * returned to normal and the user was told nothing. Chat was worse — the
 * composer cleared itself before `onSend`, and a closed socket dropped the
 * text with no trace (see hooks/useThread.ts).
 *
 * The helper fires a CustomEvent — the same channel lib/api.ts already uses
 * for `pear:plus-required` — so any surface can listen without threading a
 * callback through every card. It carries HUMAN COPY ONLY: no API JSON and no
 * error codes, because the review's prescription is that ordinary copy never
 * shows them (the technical detail belongs in console.error, which every call
 * site keeps).
 */
export const ACTION_FAILED_EVENT = 'pear:action-failed';

/**
 * `what` is phrased as the thing that did not happen — `reportActionFailure(
 * 'send that message')` renders "Couldn't send that message — try again."
 */
export function reportActionFailure(what: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ACTION_FAILED_EVENT, { detail: { what } }));
}
